import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const resourcesItemDefaultVariants = {}
const resourcesItemCompoundVariants = []

const resourcesItemSlotNames = [
  [
    "root",
    "resources-item__root"
  ],
  [
    "contentWrapper",
    "resources-item__contentWrapper"
  ],
  [
    "link",
    "resources-item__link"
  ],
  [
    "title",
    "resources-item__title"
  ],
  [
    "text",
    "resources-item__text"
  ]
]
const resourcesItemSlotFns = /* @__PURE__ */ resourcesItemSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, resourcesItemDefaultVariants, getSlotCompoundVariant(resourcesItemCompoundVariants, slotName))])

const resourcesItemFn = memo((props = {}) => {
  return Object.fromEntries(resourcesItemSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const resourcesItemVariantKeys = []
const getVariantProps = (variants) => ({ ...resourcesItemDefaultVariants, ...compact(variants) })

export const resourcesItem = /* @__PURE__ */ Object.assign(resourcesItemFn, {
  __recipe__: false,
  __name__: 'resourcesItem',
  raw: (props) => props,
  variantKeys: resourcesItemVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, resourcesItemVariantKeys)
  },
  getVariantProps
})